export enum NetworkErrorCode {
    FUTURE_DATE_NOT_AVAILABLE = 'FUTURE_DATE_NOT_AVAILABLE', //
    STATUS_CHANGE_NOT_ALLOWED = 'STATUS_CHANGE_NOT_ALLOWED',
    NOT_AT_JOB_LOCATION = 'NOT_AT_JOB_LOCATION',
    NOT_ON_TIME = 'NOT_ON_TIME',
    NOT_FIXED_PRICE_JOB = 'NOT_FIXED_PRICE_JOB',
    NOT_ACTIVE_HAULER = 'NOT_ACTIVE_HAULER',
    ITEM_NOT_FOUND = 'ITEM_NOT_FOUND',
    GENERAL_ERROR = 'GENERAL_ERROR',
    NO_ACTIVE_PROVIDERS_IN_SELECTED_MSA = 'NO_ACTIVE_PROVIDERS_IN_SELECTED_MSA',
    CLIENT_PAYMENT_ACCOUNT_NOT_FOUND = 'CLIENT_PAYMENT_ACCOUNT_NOT_FOUND',
    CLIENT_ALREADY_HAS_ACTIVE_JOB = 'CLIENT_ALREADY_HAS_ACTIVE_JOB',
    CLIENT_INVALID_CHARGE_ACCOUNT = 'CLIENT_INVALID_CHARGE_ACCOUNT'
}



// WEBPACK FOOTER //
// ./src/types/NetworkErrorCode.ts